export default __webpack_public_path__ + "static/media/npm_ico.67425d42.svg";